import ContactScript from "./ContactScript";
import ContactCard  from ".././components/ContactCard.js"
import ".././styles/Contact.css";
function Contact() {
    return (
        <div>
            <div className="container">
                <div className="contact-banner-container">
                    <div className="contact-banner">
                        <h1>Contact Us</h1>
                    </div>
                </div>
            </div>
            <div className="container">
                <p className="contact-text">
                    Have a question or want to get in touch? Please use the form below, and we look forward to hearing from you.
                </p>
                <iframe id="contact-fields"src="https://forms.fillout.com/t/cRYJdhsiY7us"  width="100%" height="710px" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
            </div>
            <div className="container">
                <div className="sub-container" id="otherCommunication">
                    <h2 className="section-title">Other Ways to Communicate</h2>
                    <p>
                        Communication is key! We want to hear your inquiries, questions, and concerns to gain a better understanding of your needs. You can communicate with our staff, 
                        board members, and even the President. Please do not hesitate to reach out to us. 
                    </p>
                    <ul>
                        <li><p><b> Office's Phone Number: </b>(204) 775-4928</p></li>
                        <li><p><b> Office's Email: </b>thenewpccm@gmail.com</p></li>
                        <li><p><b> President's Email: </b>president@thenewpccm.ca</p></li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Contact;